import { useEffect, useState } from "react";
import {globalApiError} from "../utils/generalApiError";
import { MyNavbar } from "../elementos/Navbar";
import { Link } from "react-router-dom";
import { useCategoriaStore } from "../store/CategoriaStore";
import { Categoria } from "../DTO/Categoria";
import { TablaCategorias } from "./TablaCategorias";
import ModalBasic from "../elementos/Modal";
import toast from "react-hot-toast";
import LoadingModal from "../elementos/LoadingModal";
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Categorias = () => {
  const { findAllCategorias, eliminarCategoria } = useCategoriaStore();
  const [categorias, setCategorias] = useState<Categoria[]>([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [idCategoria, setIdCategoria] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Cargando categorías...");
  const [disabled, setDisabled] = useState(false);

    useEffect( ()  => {
     fetchAllCategorias();
  }, []);

  const fetchAllCategorias = async () => {
    setLoadingMessage("Cargando categorías...");
    setLoading(true);
    try {
      const response = await findAllCategorias();
      setCategorias(response);
    } catch (error) {
      toast.error(globalApiError(error));
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    setDisabled(true);
    setLoadingMessage("Eliminando categoría...");
    setLoading(true);
    try {
      await eliminarCategoria(idCategoria);
      await fetchAllCategorias();
      setModalOpen(false);
        toast.success("Se ha eliminado correctamente");
    } catch (error) {
        toast.error(globalApiError(error));
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  }

  const handleOpenModal = (id:number) => {
      setIdCategoria(id);
      setModalOpen(true);
  }




  return (
    <div className="div-global" style={{ padding: "0" }}>
      <LoadingModal show={loading} message={loadingMessage} />
      <MyNavbar />

      <div
        className="div-titulo"
        style={{ paddingLeft: "5%", paddingRight: "5%" }}
      >
        <h1
          className="text-center-tt"
          style={{ marginTop: "5%", marginBottom: "5%" }}
        >
          Categorias
        </h1>

        <div className="card shadow-sm  mi-card-personalizada">
          <div className="card-body p-3">
            <TablaCategorias>
              {categorias.length > 0 ? (
                categorias.map((categoria, index) => (
                  <tr key={index}>
                    <td>{categoria.nombre}</td>
                    <td>
                      <Link
                        to={`/editarCategoria/${categoria.id}`}
                        className="btn btn-sm btn-primary me-2 btn-accions"
                         aria-label="Editar categoria"
                        title="Editar categoria"
                      >
                        <FontAwesomeIcon icon={faPenToSquare} className="medida-icono"  />
                      </Link>
                      <button
                      disabled={disabled}
                      onClick={() => handleOpenModal(categoria.id)}
                        className="btn btn-sm btn-danger me-2 btn-accions"
                         aria-label="Borrar categoria"
                        title="Borrar categoria"
                      >
                         <FontAwesomeIcon icon={faTrashCan} className="medida-icono"  />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No hay categorias disponibles.
                  </td>
                </tr>
              )}
            </TablaCategorias>

            <div className="div-botones-agregar-futuras">
              <Link
                className="btn btn-primary boton-agregar mt-3"
                to={"/crearCategoria"}
              >
                <p className="title-botones"> Agregar Categoria</p>
              </Link>
            </div>
              <ModalBasic
              show={modalOpen}
              onClose={handleCloseModal}
              onConfirm={handleConfirmDelete}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
